export const vacWebsite = 'https://www.vacheron-constantin.com';
export const vacStoreWebsite = 'https://stores.vacheron-constantin.com';
export const yextFormPath = 'contact-services?q=';
export const conciergePath = 'contact-our-concierge.html';